import type { IconNode } from '../types';

/**
 * @name olive
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTAgMTAgNC0zIiAvPgogIDxwYXRoIGQ9Im0xMCA3IDQgMyIgLz4KICA8ZWxsaXBzZSBjeD0iMTIiIGN5PSIxMiIgcng9IjkiIHJ5PSIxMCIgLz4KICA8cGF0aCBkPSJtMiAyMiA1LTUiIC8+CiAgPHBhdGggZD0iTTE4LjY5IDUuMzEgMjIgMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/olive
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const olive: IconNode = [
  ['path', { d: 'm10 10 4-3', key: 'afflnh' }],
  ['path', { d: 'm10 7 4 3', key: '1cbuel' }],
  ['ellipse', { cx: '12', cy: '12', rx: '9', ry: '10', key: '9s5mxj' }],
  ['path', { d: 'm2 22 5-5', key: '1i4q4v' }],
  ['path', { d: 'M18.69 5.31 22 2', key: 'gbt390' }],
];

export default olive;
